/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/phone-frame': {
    width: 354,
    height: 525,
    viewBox: '0 0 354 525',
    data: '<path pid="0" d="M312.603 0H41.22C18.576 0 0 18.576 0 41.22v526.666c0 22.644 18.576 41.22 41.22 41.22h271.56c22.644 0 41.22-18.399 41.22-41.22V41.22C353.823 18.576 335.247 0 312.603 0zM133.391 29.721h86.864c2.83 0 4.953 2.3 4.953 4.954 0 2.83-2.299 4.953-4.953 4.953h-86.864c-2.83 0-4.953-2.3-4.953-4.953 0-2.83 2.3-4.954 4.953-4.954zm43.521 558.863c-11.323 0-20.522-9.199-20.522-20.522 0-11.322 9.199-20.521 20.522-20.521 11.322 0 20.521 9.199 20.521 20.521 0 11.323-9.199 20.522-20.521 20.522zm148.251-55.727H28.66V65.28h296.503v467.577z" _fill="#fff"/>'
  }
})
